import { render, staticRenderFns } from "./PropostaMenu.vue?vue&type=template&id=740e9370&scoped=true&"
import script from "./PropostaMenu.vue?vue&type=script&lang=js&"
export * from "./PropostaMenu.vue?vue&type=script&lang=js&"
import style0 from "./PropostaMenu.vue?vue&type=style&index=0&id=740e9370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e9370",
  null
  
)

export default component.exports